import { StrictMode, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { SaveColorButtonsWrapper } from "./components/save-color/save-color-buttons-wrapper";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../../src/js/api/queryClient";

const SaveColorContext = createContext();
export const useSaveColor = () => useContext(SaveColorContext);
function SaveColorProvider({ data, children }) {
  return (
    <SaveColorContext.Provider value={data}>
      {children}
    </SaveColorContext.Provider>
  );
}

function SaveColorRenderer() {
  const elements = document.querySelectorAll(".react-save-color");
  if (!elements) return;
  elements.forEach((element) => {
    let initialProps = {};
    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(error, "Could not parse initial props JSON for SaveColor");
    }
    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <SaveColorProvider data={initialProps}>
            <SaveColorButtonsWrapper />
          </SaveColorProvider>
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initSaveColor = () => {
  if (document.readyState !== "loading") {
    SaveColorRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", SaveColorRenderer);
  }
  document.addEventListener("DOMContentLoaded", () => {
    window.emitter?.addListener("rerenderReactSaveColorComponents", () => {
      SaveColorRenderer();
    });
  });
};

export { SaveColorButtonsWrapper, SaveColorProvider };
